/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Ignore_All_ButtonInputs */

const en_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore All`)
};

const fr_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ignorer`)
};

const de_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle ignorieren`)
};

const it_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignora tutto`)
};

const ru_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игнорировать всё`)
};

const es_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar todo`)
};

const zh_cn2_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略所有`)
};

const ja_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて無視`)
};

const hi_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी को अनदेखा करें`)
};

const pt_pt2_work_order_publish_ignore_all_button = /** @type {(inputs: Work_Order_Publish_Ignore_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar tudo`)
};

/**
* | output |
* | --- |
* | "Ignore All" |
*
* @param {Work_Order_Publish_Ignore_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_ignore_all_button = /** @type {((inputs?: Work_Order_Publish_Ignore_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Ignore_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_ignore_all_button(inputs)
	if (locale === "de") return de_work_order_publish_ignore_all_button(inputs)
	if (locale === "it") return it_work_order_publish_ignore_all_button(inputs)
	if (locale === "ru") return ru_work_order_publish_ignore_all_button(inputs)
	if (locale === "es") return es_work_order_publish_ignore_all_button(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_ignore_all_button(inputs)
	if (locale === "ja") return ja_work_order_publish_ignore_all_button(inputs)
	if (locale === "hi") return hi_work_order_publish_ignore_all_button(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_ignore_all_button(inputs)
	return en_work_order_publish_ignore_all_button(inputs)
});